import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a18466"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "warning" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-triangle-exclamation" })
  ]),
  /*#__PURE__*/_createTextVNode(" Video přehrávač byl odpojen")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "note" }, "Zavřete okno a otevřete Lector Code Viewer znovu", -1))
const _hoisted_4 = {
  key: 0,
  class: "debug"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "LectorCodeViewer", -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lector Code", -1))
const _hoisted_8 = {
  key: 0,
  style: {"min-width":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "RecordingSessionId", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Loaded", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Chapter", -1))
const _hoisted_13 = { style: {"display":"flex","gap":"0.5em"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Workspaces", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lector State", -1))
const _hoisted_16 = { style: {"min-width":"100%"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "lectorEditorReady", -1))
const _hoisted_18 = {
  key: 1,
  class: "IDEWindowWrapper"
}
const _hoisted_19 = {
  key: 2,
  class: "message"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-circle-info" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" V tomto videu se nepracuje se soubory... ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-cog fa-spin",
  style: {"animation-duration":"4.0s","animation-iteration-count":"infinite"}
}, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Příprava spuštění editoru... ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]

import { ref, withDefaults, watch, nextTick, computed, reactive, onMounted } from 'vue';
import * as rac from '@primafuture/remote-async-call';
import * as IDEWindow from './IDE/IDEWindow.vue';
import * as IDETextEditor from './IDE/IDETextEditor.vue';
import * as IDETabs from './IDE/IDETabs.vue';
import * as IDESideBarContentTabFileSystem from './IDE/IDESideBarContentTabFileSystem.vue';
import * as IDESideBarContentTabDownload from './IDE/IDESideBarContentTabDownload.vue';
import * as IDESideBarContentTabSettings from './IDE/IDESideBarContentTabSettings.vue';
import ReconnectingWebSocket from 'reconnecting-websocket';
import * as textExtensionsList from 'textextensions';
import streamSaver from 'streamsaver';
import { WritableStream } from "web-streams-polyfill/ponyfill";
import * as config from '@/config';


interface ServerPlaybackSessionClient {
	id: string,
	role: string,
}
// aktualni id playback session klienta
interface LectorCodeState {
	recordingSessionId: string,
	loaded: boolean,
	playing: boolean,
	stopped: boolean,
	usable: boolean,
	chapter: {
		title: string,
		subtitle: Array<string>,
		name: string,
	},
}
// stav lector code
interface ServerEditorsItem {
	fileName: string,
	isDirty: boolean,
	isUntitled: boolean,
	languageId: string,
}
interface UserOpenFile {
	filename: string,
}
enum FileContentType {
	text = "text",
	binary = "binary",
	image = "image",
	unknown = "unknown",
}
interface ServerDirectoryContent {
	dirname: string,
	directoryContent: {
		directories: Array<string>,
		files: Array<string>,
	},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LectorCodeViewer',
  props: {
    debug: { type: Boolean, default() {
		return false;
	} },
    playbackSessionId: { default() {
		return null;
	} }
  },
  setup(__props: any) {

const props = __props as { debug: boolean, playbackSessionId: string|null }




function onClick() {
	window.parent.postMessage("LectorCodeViewer.onClick", document.referrer);
}

const modelLanguagesByExtension = [
	['.js', 'javascript'],
	['.php', 'php'],
	['.css', 'css'],
	['.less', 'less'],
	['.scss', 'scss'],
	['.html', 'html'],
	['.sql', 'sql'],
	['.ini', 'ini'],
	['.md', 'markdown'],
	['.xml', 'xml'],
	['.ts', 'typescript'],
	['.sh', 'shell'],
	['.py', 'python'],
];

// instance komponenty IDEWindow
const IDEWindowInstance = ref<InstanceType<typeof IDEWindow.default>|null>(null);

// konfigurace app
const appConfig = ref<config.IAppConfig|null>(null);
onMounted(async () => {
	appConfig.value = await config.loadConfig();
});

// seznam cekajicich volani
const pendingCalls = ref<Set<number>>(new Set());

// definice pro playback session client
const playbackSessionClientId = ref<string|null>(null);
// seznam klientu v aktualni playback session
const playbackSessionClients = ref<Array<ServerPlaybackSessionClient>>([]);
// zda-li je odpojen video player
const isVideoPlayerPlaybackSessionClientDisconnected = computed(() => {
	// odpojen je pokud je znam id aktualniho klienta a v seznamu klientu neni klient s roli video-player
	return playbackSessionClientId.value !== null && playbackSessionClients.value.find((client) => client.role == "video-player") === undefined;
});

function closeWindow() {
	window.close();
}

const lectorCodeState = ref<LectorCodeState|null>(null);


// definice pro stav lektora
class LectorStateActiveEditor {
	// nazev souboru
	filename: string|null = null;
	// aktualni pozice kursoru
	cursorPosition: IDETextEditor.PropsOptions["virtualCursorPosition"] = null;
	// seznam vyberu text v editoru
	selections: IDETextEditor.PropsOptions["virtualSelections"] = [];
}
class LectorState {
	// zda-li je pripraveny editor lektora
	lectorEditorReady = false;
	// aktivni editor lektora
	activeEditor:LectorStateActiveEditor;
	// seznam editoru, ktere ma otevreny lektor
	openEditors:Array<ServerEditorsItem> = [];

	constructor() {
		this.activeEditor = new LectorStateActiveEditor();
	}
}
// aktualni stav lektora
const lectorState = ref<LectorState>(new LectorState());

// obsah textoveho editoru
class Editor {
	// textovy obsah
	content = "";
	// jazyk obsahu
	modelLanguage = "";
}
const editor = ref<Editor>(new Editor);

// seznam tabu
const tabsList = ref<IDETabs.PropsOptions["tabsList"]>([]);
// nazev souboru aktivniho tabu
const activeTabFilename = ref<string|null>(null);
// zdali a jaky tab je uzivatelem natvrdo vybrany
const forcedSelectedTabFilename = ref<string|null>(null);

// nasledovani aktivity lektora (volba aktualniho editoru, nasledovani kurzoru, atd)
class FollowLectorActivity {
	// zda-li je nasledovani aktivity lektora aktivni
	active = true;
	// casovac pro vyexpirovani aktivity studenta
	studentActivityTimeoutTimer:number|null = null;
}
const followLectorActivity = ref<FollowLectorActivity>(new FollowLectorActivity);

// zda-li je aktivni lektorovo editor
const isLectorEditorActive = computed(() => {
	return lectorState.value.activeEditor.filename !== null && lectorState.value.activeEditor.filename === activeTabFilename.value;
});

// historie stavu editoru podle nazvu souboru
const editorStateByFilename = new Map<string, IDETextEditor.EditorState>();

// uzivatelem otevrene soubory
const userOpenFiles = ref<Array<UserOpenFile>>([]);

// typ obsahu otevreneho souboru
const activeTabFileContentType = ref<FileContentType|null>(null);

// vraceni hodnot do vychoziho stavu. Zavola se napr. pri zmene recording session id
function resetAll() {
	// vsechno vynulovat
	// vynulovat stav lektora
	lectorCodeState.value = null;
	// nastavit ze lektorovo editor neni pripraven
	lectorState.value.lectorEditorReady = false;
	// vynulovat obsah editoru
	editor.value.content = "";
	// vynulovat aktivni editor
	lectorState.value.activeEditor.filename = null;
	// vynulovat pozici kurzoru
	lectorState.value.activeEditor.cursorPosition = null;
	// vynulovat seznam vyberu v editoru
	lectorState.value.activeEditor.selections.splice(0, lectorState.value.activeEditor.selections.length);
	// vynulovat seznam otevrenych editoru lektora
	lectorState.value.openEditors.splice(0, lectorState.value.openEditors.length);
	// vynulovat seznam otevrenych editoru uzivatelem
	userOpenFiles.value.splice(0, userOpenFiles.value.length);
	// vynulovat seznam workspace
	workspaces.value.splice(0, workspaces.value.length);
	// vynulovat sledovane slozky
	watchedDirectories.value.splice(0, watchedDirectories.value.length);
	// vynulovat druh aktivniho souboru
	activeTabFileContentType.value = null;
	// vynulovat aktivni tab
	activeTabFilename.value = null;
}

// spojeni na server
watch(appConfig, () => {
	if (!appConfig.value) {
		return;
	}

	const backendWebSocketConnection = new ReconnectingWebSocket(appConfig.value.api.websocketUrl, [], {
		maxReconnectionDelay: 2000,
		minReconnectionDelay: 1000,
		debug: false,
	});
	racProxy = new rac.RACProxy(new rac.WebsocketCommunicationConnection(backendWebSocketConnection));

	// odchytit udalost, ze by doslo k uspesnemu spojeni s backendem a vytvorit RAC proxy
	racProxy.onConnected(() => {
		//console.log('Backend communication broker connected');

		// odoznacit ze je ready a pockat az nastane ready udalost
		racProxyReady = false;
		if (props.playbackSessionId && racProxyPlaybackSessionConnected.has(props.playbackSessionId)) {
			racProxyPlaybackSessionConnected.delete(props.playbackSessionId);
		}
		// promaznout cekajici volani
		pendingCalls.value.clear();

		racProxy.onRemoteProcedureRegistered('ready', async () => {
			//console.log('onRemoteProcedureRegistered ready');
			if (props.playbackSessionId) {
				racProxyReady = true;
				connectToPlaybackSession();
			}
		});

		// auto ping-pong pro websocket keep-alive
		setInterval(() => {
			racProxyCall('ping', []);
		}, 30000);
	});
});

let racProxy:any = null;
let racProxyPlaybackSessionConnected = new Set<string>();
let racProxyReady = false;

async function racProxyCall(methodName:string, ...args:any[]) {
	const callId = Date.now();
	pendingCalls.value.add(callId);
	//await new Promise((resolve) => setTimeout(resolve, 2000));
	let result;
	try {
		result = await racProxy.call(methodName, ...args);
	}catch (err) {
		console.error("RAC Proxy Call failed", {methodName, args, err});
		console.error(err);
		console.error((err as Error).stack);
		//alert("Interní chyba systému");
	}
	pendingCalls.value.delete(callId);
	return result;
}

// funkce pro pripojeni na backend
async function connectToPlaybackSession() {
	// console.log('ConnectToPlaybackSession', {
	// 	playbackSessionId: props.playbackSessionId,
	// 	racProxyReady,
	// 	connectedPlaybackSessionIds: [...racProxyPlaybackSessionConnected],
	// });

	// pripojit se na danou playback session pokud neni nullova a je ready, ale jeste neni connected
	if (props.playbackSessionId && racProxyReady && racProxyPlaybackSessionConnected.has(props.playbackSessionId) === false) {
		// odchytnout udalost ze doslo ke zmene stavu playback session
		racProxy.subscribe('playbackSessionChanged', async (args:any) => {
			const [newPlaybackSessionState] = args;
			//console.log({newPlaybackSessionState});
			playbackSessionClients.value = newPlaybackSessionState.clients;
		});

		// odchytnout udalost ze doslo ke zmene stavu lectorCode
		racProxy.subscribe('lectorCodeChanged', async (args:any) => {
			const [newLectorCodeState] = args;
			//console.log({newLectorCodeState});

			// zjistit id predchozi recording ression
			const previousRecordingSessionId = lectorCodeState.value != null ? lectorCodeState.value.recordingSessionId : null;

			// pokud je lektor code nacten, ale zmenila se recording session nebo predtim zadna nebyla,
			// tak to vse vynulovat do vychoziho stavu
			if (previousRecordingSessionId != newLectorCodeState.recordingSessionId) {
				resetAll();
			}

			// pokud predtim nebyl znam zadnys stav, tak ho nastavit naprimo
			// jinak pomoci Object.assign, abychom neztratili reaktivitu
			if (lectorCodeState.value == null) {
				lectorCodeState.value = newLectorCodeState;
			}else {
				Object.assign(lectorCodeState.value, newLectorCodeState);
			}

			if (lectorCodeState.value) {
				// pokud kod neni nacteny, tak nastavit, ze to jeste neni ready
				// Pokud uz je nacteny, tak muzem rict, ze je ready a pockame si
				// na udalosti, ktere nastavi seznam editoru, pozice v editoru atd...
				if (lectorCodeState.value.loaded == false) {
					lectorState.value.lectorEditorReady = false;
				}else {
					lectorState.value.lectorEditorReady = true;
				}
			}
		});

		// odchytit udalost ze doslo ke zmene stavu handleru v lector code
		racProxy.subscribe('lectorCodeHandlerStateChanged', async (args:any) => {
			const [lectorCodeHandlerState] = args;
			//console.log({lectorCodeHandlerState});
			if (lectorCodeHandlerState.key == "activeEditor") {
				const newActiveEditor = lectorCodeHandlerState.state;
				//console.log({newActiveEditor});

				lectorState.value.activeEditor.filename = newActiveEditor !== null && newActiveEditor.document?.fileName !== undefined ? newActiveEditor.document.fileName : null;
			}else if (lectorCodeHandlerState.key == "activeEditorSelections") {
				const newActiveEditorSelections = lectorCodeHandlerState.state;
				//console.log({newActiveEditorSelections});

				lectorState.value.activeEditor.selections.splice(0, lectorState.value.activeEditor.selections.length, ...newActiveEditorSelections.map((selection:any) => ({
					start: {
						lineNumber: selection.start.line + 1,
						column: selection.start.character + 1,
					},
					end: {
						lineNumber: selection.end.line + 1,
						column: selection.end.character + 1,
					},
				})));

				if (newActiveEditorSelections.length > 0) {
					const firstActiveEditorSelection = newActiveEditorSelections[0];

					if ("active" in firstActiveEditorSelection) {
						lectorState.value.activeEditor.cursorPosition = {
							lineNumber: firstActiveEditorSelection.active.line + 1/*zacina nulou*/,
							column: firstActiveEditorSelection.active.character + 1/*zacina nulou*/,
						};
					}
				}
			}else if (lectorCodeHandlerState.key == "editors") {
				const newEditors = lectorCodeHandlerState.state;
				//console.log({newEditors});

				lectorState.value.openEditors.splice(0, lectorState.value.openEditors.length, ...newEditors);
			}else if (lectorCodeHandlerState.key == "workspaceFolders") {
				const newWorkspaceFolders = lectorCodeHandlerState.state;
				//console.log({newWorkspaceFolders});
				// upravit seznam workspace podle seznamu slozek
				// zjistit aktualni seznam slozek
				const currentWorkspaceFolders = workspaces.value.map((workspace) => workspace.getDirname());
				// zjistit, ktere slozky pribyly
				const workspaceFoldersToAdd = newWorkspaceFolders.filter((v:string) => !currentWorkspaceFolders.includes(v));
				// zjistit, ktere slozky zmizely
				const workspaceFoldersToRemove = currentWorkspaceFolders.filter((v:string) => !newWorkspaceFolders.includes(v));
				//console.log({workspaceFoldersToAdd});
				//console.log({workspaceFoldersToRemove});
				// vyfiltrovat slozky, aby tam zustaly jen ty co maji
				workspaces.value = workspaces.value.filter((workspace) => !workspaceFoldersToRemove.includes(workspace.getDirname()));
				// pridat tam nove slozky
				for (const folder of workspaceFoldersToAdd) {
					workspaces.value.push(new IDESideBarContentTabFileSystem.Workspace(folder));
				}
			}
		});

		// odchytit udalost, ze doslo ke zmene obsahu souboru
		racProxy.subscribe('fileChanged', async (args:any) => {
			const [fileChangedInfo] = args;
			//console.log({fileChangedInfo});
			// pokud se shoduje nazev souboru se souborem, ktery je zrovna aktivni v editoru
			// tak aplikovat obsah souboru
			if (fileChangedInfo.filename == activeTabFilename.value) {
				editor.value.content = fileChangedInfo.content;
			}
		});

		// odchytit udalost, ze doslo ke zmene obsahu slozky
		racProxy.subscribe('directoryChanged', async (args:any) => {
			const [directoryChangedInfo] = args;
			//console.log({directoryChangedInfo});
			setWorkspacesDirectoriesContent([directoryChangedInfo]);
		});

		// odchytit udalost, ze doslo ke zmene stavu stahovani
		racProxy.subscribe('downloadStateChanged', async (args:any) => {
			const [downloadStateChangedInfo] = args;
			//console.log({downloadStateChangedInfo});
			const download = downloads.value.find((downloadItem) => downloadItem.downloadId == downloadStateChangedInfo.id);
			if (download) {
				if (downloadStateChangedInfo.state == 'ready') {
					download.totalSize = downloadStateChangedInfo.size;
				}
			}
		});

		resetAll();

		// provest pripojeni na danou playback session id
		const role = 'lector-code-viewer';
		// pridat playback session id do seznamu jiz pripojenych
		racProxyPlaybackSessionConnected.add(props.playbackSessionId);
		// pro pripadne budouci znovupripojeni je potreba odstranit flag, ze je to ready, aby si to
		// na nove ready pockalo
		racProxyReady = false;
		const connectResult = await racProxyCall('connect', [props.playbackSessionId, role]);
		//console.log({connectResult});
		playbackSessionClientId.value = connectResult.playbackSessionClientId;
	}
}
// pokud se zmeni playbackSessionId (napr. z null na nejakou hodnotu), tak se pripojit na backend
watch(() => props.playbackSessionId, () => {
	connectToPlaybackSession();
});

// pokud se zmenil seznam editoru lektora, nebo se zmenil aktivni editor lektora, nebo se zmenila forcnuta zalozka
// tak prepocitat seznam tabu a zjistit ktery je aktivni
watch([
	lectorState.value.openEditors,
	() => lectorState.value.activeEditor.filename,
	forcedSelectedTabFilename,
	() => userOpenFiles.value.map((userOpenFile) => userOpenFile.filename),
], () => {
	tabsList.value = lectorState.value.openEditors.map((editor) => {
		return {
			filename: editor.fileName,
			name: editor.fileName.split("/").slice(-1).join("/"),
			active: (
				// pokud je rucne vybrany tab a ten se shoduje s aktualne prochazenym
				(forcedSelectedTabFilename.value !== null && forcedSelectedTabFilename.value == editor.fileName)
				||
				// nebo pokud neni rucne vybrany tab a lektor ma vybrany editor a ten se shoduje s aktualne prochazenym
				(forcedSelectedTabFilename.value === null && lectorState.value.activeEditor.filename !== null && lectorState.value.activeEditor.filename == editor.fileName)
			),
			// zda-li je tato zalozka editor, ktery ma lektor jako aktivni
			isLectorActiveEditor: lectorState.value.activeEditor.filename !== null && lectorState.value.activeEditor.filename == editor.fileName,
			openByLector: true,
		};
	}).concat(userOpenFiles.value.filter((userOpenFile) => {
		// vynechat ty soubory co ma otevreny lektor, aby tam nebyly 2 zalozky se stejnym
		// souborem
		return lectorState.value.openEditors.find((editor) => editor.fileName == userOpenFile.filename) == undefined;
	}).map((userOpenFile) => {
		return {
			filename: userOpenFile.filename,
			name: userOpenFile.filename.split("/").slice(-1).join("/"),
			active: (
				// pokud je rucne vybrany tab a ten se shoduje s aktualne prochazenym
				(forcedSelectedTabFilename.value !== null && forcedSelectedTabFilename.value == userOpenFile.filename)
				||
				// nebo pokud neni rucne vybrany tab a lektor ma vybrany editor a ten se shoduje s aktualne prochazenym
				(forcedSelectedTabFilename.value === null && lectorState.value.activeEditor.filename !== null && lectorState.value.activeEditor.filename == userOpenFile.filename)
			),
			// zda-li je tato zalozka editor, ktery ma lektor jako aktivni
			isLectorActiveEditor: lectorState.value.activeEditor.filename !== null && lectorState.value.activeEditor.filename == userOpenFile.filename,
			openByLector: false,
		};
	}));
	const activeTab = tabsList.value.find((tab) => tab.active);
	activeTabFilename.value = activeTab !== undefined ? activeTab.filename : null;
	//console.log({activeTabFilename: activeTabFilename.value});
});

function getFileContentType(filename:string|null) : FileContentType|null {
	if (!filename) {
		return null;
	}
	const extension = filename.split('.').slice(-1).pop();
	// pokud nema soubor zadnou koncovku, tak to bude nejspis textovy jako napr. LICENCE, atd..
	if (!extension) {
		return FileContentType.text;
	}
	// pokud je pripona v seznamu textovych pripon, tak jde o textovy soubor
	if (textExtensionsList.default.includes(extension)) {
		return FileContentType.text;
	}
	// vsechno ostatni je neznamy typ souboru
	return FileContentType.unknown;
}

// pokud se zmenil aktivni tab (soubor, ktery je otevreny v editoru), tak
// musime poresit obsah a stav editoru
watch(activeTabFilename, async (value, oldValue) => {
	//console.warn("activeTabFilename changed", {value, oldValue});
	// pokud je rucne vybrany nejaky tab, ale ve vysledku neni aktivni tab,
	// protoze ten rucne vybrany neexistuje, tak ten zrusit vybrani
	if (forcedSelectedTabFilename.value !== null && activeTabFilename.value === null) {
		//console.log("Forced selected tab not exists. Unselect");
		// zrusit rucne vybrany tab
		forcedSelectedTabFilename.value = null;
		// ukoncit a pockat az dojde k nove zmene aktivniho tabu
		// a funkce se nam zavola znovu
		return;
	}

	// zjistit typ souboru aktualniho a predchoziho, zda-li jde o textovy soubor nebo neco binarniho
	const previousActiveTabFilename = oldValue;
	const previousActiveTabContentType = getFileContentType(previousActiveTabFilename);
	activeTabFileContentType.value = getFileContentType(activeTabFilename.value);
	//console.log({previousActiveTabContentType});
	//console.log({activeTabFileContentType:activeTabFileContentType.value});

	// v zavislosti na typu souboru se rozhodnout co dal
	// pokud jde o textovy soubor, tak poresime textovy editor
	if (activeTabFileContentType.value == FileContentType.text || previousActiveTabContentType == FileContentType.text) {
		// nastavit stav a obsah editoru
		if (IDEWindowInstance.value) {
			const IDETextEditorInstance = IDEWindowInstance.value.getTextEditorInstance();

			// pokud byl predtim vybrany nejaky tab, tak si chceme ulozit stav
			// textoveho editoru, aby kdyz tam uzivatel preklikne, aby to bylo v tom
			// predchozim stavu a ne pokazde od zacatku s pozici nahore
			const previousActiveTabFilename = oldValue;
			if (previousActiveTabFilename && previousActiveTabContentType == FileContentType.text) {
				// zjistit aktualni stav textoveho editoru, abychom si ho poznamenali
				const editorState = IDETextEditorInstance.value.getEditorState();
				//console.log({editorState });

				if (editorState) {
					//console.warn('SAVE EDITOR STATE', previousActiveTabFilename, editorState);
					editorStateByFilename.set(previousActiveTabFilename, editorState);
				}
			}

			// pokud je nejaky aktivni tab
			if (activeTabFilename.value !== null && activeTabFileContentType.value == FileContentType.text) {
				const currentFilename = activeTabFilename.value;

				// podle nazvu souboru nastavit jazyk text
				const modelLanguage = modelLanguagesByExtension.find((modelLanguage) => currentFilename.endsWith(modelLanguage[0]));
				editor.value.modelLanguage = modelLanguage !== undefined ? modelLanguage[1] : "";

				// upozornit server ze chceme sledovat zmeny obsahu souboru
				// a rovnou vraceny obsah souboru dat do editoru
				const watchedFiles = [currentFilename];
				//console.log("Watch files", {watchedFiles });
				//editor.value.content = "";
				IDETextEditorInstance.value.setContent("");

				// poznamenat si id volani, abychom evidovali seznam cekajicich a pripadne zobrazili loader
				const watchFilesResult = await racProxyCall('watchFiles', [watchedFiles]);

				// vytahnout si vraceny soubor
				const file = watchFilesResult.files[0];
				// pri vytvoreni noveho souboru jeste v drobny moment nemusi existovat,
				// tak opodminkovat a pripadne nastavit prazdny obsah
				const fileContent = file ? file.content : "";
				//editor.value.content = fileContent
				IDETextEditorInstance.value.setContent(fileContent);

				// pokud je zapnute sledovani lektora a jde o zalozku, kde je lektor
				// tak prejit na pozici kde je lektor
				if (followLectorActivity.value.active && isLectorEditorActive.value.valueOf()) {
					goToLectorsPosition();
				}else {
					// nastavit stav editoru podle poznamenane historie
					const editorState = editorStateByFilename.has(currentFilename) ? editorStateByFilename.get(currentFilename) : null;
					if (editorState) {
						//console.warn('RESTORE EDITOR STATE', currentFilename, editorState);
						IDETextEditorInstance.value.setEditorState(editorState);
					}else {
						//console.warn('RESET EDITOR STATE', currentFilename);
						// pokud neni ulozeny stav, tak soupnout na vychozi pozici
						IDETextEditorInstance.value.setEditorState({
							cursorPosition: {
								lineNumber: 1,
								column: 1,
							},
							viewState: {
								cursorState: [],
								viewState: {
									firstPosition: {
										lineNumber: 1,
										column: 1,
									},
									firstPositionDeltaTop: 0,
									scrollLeft: 0,
								},
								contributionsState: [],
							},
						});
					}
				}
			}
		}
	}
});

// funkce, ktera nastane pokud byl rucne vybran nejaky tab
async function onSelectTab(tab:IDETabs.Tab) {
	// jen pokud se tab zmenil a neklika se na ten stejny co uz je vybrany
	if (!forcedSelectedTabFilename.value || tab.filename !== forcedSelectedTabFilename.value) {
		forcedSelectedTabFilename.value = tab.filename;
		onStudentActivity();

		// dat focus editoru
		if (IDEWindowInstance.value) {
			const IDETextEditorInstance = IDEWindowInstance.value.getTextEditorInstance();
			IDETextEditorInstance.value.focus();
		}
	}
}

// funkce nastane pokud uzivatel zavre nejaky tab
function onCloseTab(tab:IDETabs.Tab) {
	userOpenFiles.value = userOpenFiles.value.filter((userOpenFile) => userOpenFile.filename != tab.filename);
	// pokud je zavrena aktualni zalozka, tak se zpet prepnout na zalozku lektora.
	// A pokud lektor zadny otevrene soubory nema, tak vybrat posledni z tech co otevrel uzivatel
	if (tab.filename == activeTabFilename.value) {
		if (lectorState.value.activeEditor.filename) {
			// nastavi se samo
		}else {
			if (userOpenFiles.value.length > 0) {
				const lastUserOpenFile = userOpenFiles.value.slice(-1).pop()?.filename;
				if (lastUserOpenFile) {
					forcedSelectedTabFilename.value = lastUserOpenFile;
				}
			}
		}
	}
}

// odchytit zmenu stav sledovani aktivity lektora
watch(() => followLectorActivity.value.active, () => {
	// pokud je sledovani lektora zapnuto, tak zajistit, aby se prepnulo
	// na spravnou zalozku a preslo se na pozici, kde je lektor
	if (followLectorActivity.value.active == true) {
		// pokud je forcnuta nejaka zalozka, tak zrusit
		if (forcedSelectedTabFilename.value !== null) {
			// zrusit jen pokud lektor ma otevreny nejaky editor
			if (lectorState.value.openEditors.length > 0) {
				forcedSelectedTabFilename.value = null;
			}else {
				// jinak vyvolat jakoby studentskou aktivitu, aby se to zkusilo za cas
				onStudentActivity();
			}
		}

		// prejit na pozici lektora
		goToLectorsPosition();
	}
});

// funkce pro spusteni odpoctu, kdy dojde k navratu sledovani aktivity lektora
function startFollowLectorActivityTimeout() {
	// k navratu sledovani lektora dojde jen pokud se video dale prehrava
	// a pohyb lektora se meni, tak v tom pripade dojde k navratu za 5s
	// pokud je video pauznute, takze lektor nic nedela, tak
	// v tom pripade nevracet ke sledovani
	if (followLectorActivity.value.active == false) {
		const returnToFollowLectorActivity = () => {
			// vratit ke sledovani, jen pokud je video prehravane
			if (lectorCodeState.value && lectorCodeState.value.playing) {
				followLectorActivity.value.active = true;
			}
		};

		// pokud timer neexistuje, tak spustit. Pokud uz bezi, tak nechat ten spusteny
		if (!followLectorActivity.value.studentActivityTimeoutTimer) {
			followLectorActivity.value.studentActivityTimeoutTimer = setTimeout(() => {
				followLectorActivity.value.studentActivityTimeoutTimer = null;
				returnToFollowLectorActivity();
			}, 5000);
		}else {
			returnToFollowLectorActivity();
		}
	}
}

// funkce ktera bude vyvolana pri nejake aktivite studenta (napr. scroluje v editoru, oznacuje nejaky text, atd...)
function onStudentActivity() {
	//console.log('activity');
	// vypnout sledovani lektora
	followLectorActivity.value.active = false;

	// zrusit timer pokud existuje
	if (followLectorActivity.value.studentActivityTimeoutTimer) {
		clearTimeout(followLectorActivity.value.studentActivityTimeoutTimer);
		followLectorActivity.value.studentActivityTimeoutTimer = null;
	}
	// spustit casovat, ktery vrati sledovani lektora
	startFollowLectorActivityTimeout();
}
// funkce bude zavolana pokud uzivatel kliknul na textovy editor
function onTextEditorMouseDown() {
	//console.log('onTextEditorMouseDown');
	onStudentActivity();
}
// funkce bude zavolana pokud uzivatel zmackl neco na klavesnici uvnitr textoveho editoru
function onTextEditorKeyDown() {
	//console.log('onTextEditorKeyDown');
	onStudentActivity();
}
// funkce bude zavolana pokud uzivatel scroluje v textovem editoru
function onTextEditorDidScrollChange() {
	//console.log('onTextEditorDidScrollChange');
	onStudentActivity();
}
// funkce bude zavolana pokud se rucne prepne, ze (ne)ma byt sledovana aktivita lektora
async function onFollowLectorActivityChanged(newValue:boolean) {
	//console.log('onFollowLectorActivityChanged');
	followLectorActivity.value.active = newValue;

	// pokud bylo sledovani vypnuto, tak vyvolat jako studentskou aktivitu
	if (followLectorActivity.value.active == false) {
		onStudentActivity();
	}

	await racProxyCall('setPlaybackState', [followLectorActivity.value.active ? 'play' : 'pause']);
}
// funkce pro prechod v editoru na lektorovu pozici
function goToLectorsPosition() {
	if (!isLectorEditorActive.value.valueOf()) {
		//console.warn('goToLectorsPosition - lector editor is not active. skip');
		return;
	}

	if (IDEWindowInstance.value) {
		const IDETextEditorInstance = IDEWindowInstance.value.getTextEditorInstance();

		IDETextEditorInstance.value.setEditorState({
			cursorPosition: lectorState.value.activeEditor.cursorPosition,
		});
	}
}

// sledovat, ze doslo ke zmene stavu prehravani videa, abychom poznali jestli video se prehrava
// nebo bylo pauznuto
watch(() => lectorCodeState.value?.playing, () => {
	if (lectorCodeState.value) {
		// doslo ke zmene stavu prehravani
		// pokud je video prehravane, a sledovani lektora je vypnute, tak
		// po urcitem case sledovani opet spustit
		if (lectorCodeState.value.playing) {
			// spustit casovat, ktery vrati sledovani lektora
			startFollowLectorActivityTimeout();
		}
	}
});

// definice pro stav lektora
const workspaces = ref<Array<IDESideBarContentTabFileSystem.Workspace>>([]);
function getWorkspaceByDirname(dirname:string):IDESideBarContentTabFileSystem.Workspace|undefined {
	return workspaces.value.find((workspace) => workspace.matchesDirectory(dirname));
}
// pokud se zmenil seznam workspace nebo se zmenil stav rozbaleni slozky v ramci workspace souboru,
// tak musime aktualizovat sledovani slozek
const watchedDirectories = ref<Array<string>>([]);
watch(() => watchedDirectories.value.map((watchedDirectory) => watchedDirectory), async (value, oldValue) => {
	// poznamenat si id volani, abychom evidovali seznam cekajicich a pripadne zobrazili loader
	const watchedDirectoriesList = [...watchedDirectories.value];
	if (watchedDirectoriesList.length > 0) {
		//console.log('Watched directories changed', {watchedDirectoriesList});
		const watchDirectoriesResult = await racProxyCall('watchDirectories', [watchedDirectoriesList]);
		//console.log({watchDirectoriesResult});
		// vytahnout si vraceny soubor
		//const file = watchFilesResult.files[0];
		setWorkspacesDirectoriesContent(watchDirectoriesResult.directories);
	}else {
		setWorkspacesDirectoriesContent([]);
	}
});
watch([
	workspaces,
	() => workspaces.value.map((workspace) => [...workspace.getAllDirectories()].map((directory) => directory.expanded)),
], async (value, oldValue) => {
	// nejprve nakrmit seznam z hlavnich adresaru workspace
	const newWatchedDirectories = workspaces.value.map((workspace) => workspace.getDirname());
	//console.log({newWatchedDirectories});
	// a dohledat jeste, ktere slozky jsou rozbaleny a ty tam take pridat
	const expandedDirectories = workspaces.value.map((workspace) => [...workspace.getAllDirectories()].filter((directory) => directory.expanded).map((directory) => directory.filename)).flat();
	//console.log({expandedDirectories});
	// pridat rozbalene slozky
	newWatchedDirectories.splice(newWatchedDirectories.length, 0, ...expandedDirectories);
	// odstranit duplicity
	newWatchedDirectories.splice(0, newWatchedDirectories.length, ...new Set(newWatchedDirectories));
	// seradit
	newWatchedDirectories.sort();

	// zjistit, ktere slozky pribyly
	const itemsToAdd = newWatchedDirectories.filter((v:string) => !watchedDirectories.value.includes(v));
	// zjistit, ktere slozky zmizely
	const itemsToRemove = watchedDirectories.value.filter((v:string) => !newWatchedDirectories.includes(v));
	//console.log({itemsToAdd});
	//console.log({itemsToRemove});

	// odstranit
	if (itemsToRemove.length > 0) {
		watchedDirectories.value = watchedDirectories.value.filter((dirname) => !itemsToRemove.includes(dirname));
	}
	// pridat
	if (itemsToAdd.length > 0) {
		watchedDirectories.value.splice(watchedDirectories.value.length, 0, ...itemsToAdd);
	}
});

// zajistit, aby byla otevrena slozka, do ktery patri aktualne otevreny soubor v editoru
watch([
	activeTabFilename,
	() => workspaces.value.map((workspace) => [...workspace.getAllDirectories()].map((directory) => directory.expanded)),
], async (value, oldValue) => {
	if (activeTabFilename.value !== null) {
		const currentDirname = activeTabFilename.value.split('/').slice(0, -1).join('/');
		//console.log({currentDirname});

		const workspace = getWorkspaceByDirname(currentDirname);
		if (workspace) {
			//console.log({workspace})
			// najit nejblizsi rodicovskou slozku, podle nazvu slozky. Nejblizsi hledame z duvodu, ze muze byt
			// otevreny nejak soubor, ktery je zanoreny v nejake podlozce, a kdybychom hledali primo tu podslozku
			// tak bychom ji nenasli. Je potreba se k te podslozce dorozbalovat
			const directoryEntry = workspace.getTopMostDirectoryByDirname(currentDirname);
			if (directoryEntry) {
				let directory:IDESideBarContentTabFileSystem.FSEntryDirectory|null = directoryEntry;
				while (directory) {
					directory.expanded = true;
					directory = directory.getParent();
				}
			}else {
				console.warn("No directory found by given dirname", {dirname: currentDirname});
			}
		}else {
			console.warn("No workspace found for given dirname", {dirname: currentDirname});
		}
	}
});

function setWorkspacesDirectoriesContent(directoriesContent:Array<ServerDirectoryContent>) {
	for (const directoryContent of directoriesContent) {
		//console.log({directoryContent})
		const workspace = getWorkspaceByDirname(directoryContent.dirname);
		if (workspace) {
			//console.log({workspace})
			const directoryEntry = workspace.getDirectoryByDirname(directoryContent.dirname);
			if (directoryEntry) {
				directoryEntry.setContent(directoryContent.directoryContent);
			}else {
				console.warn("No directory found by given dirname", {dirname: directoryContent.dirname});
			}
		}else {
			console.warn("No workspace found for given dirname", {dirname: directoryContent.dirname});
		}
	}
}

// aktualizovat selected stav souboru, podle toho jaky aktivni soubor je otevreny v editoru
watch([
	activeTabFilename,
	tabsList,
	() => workspaces.value.map((workspace) => [...workspace.getAllFiles()].map((file) => file.filename)),
], async (value, oldValue) => {
	for (const workspace of workspaces.value) {
		for (const file of workspace.getAllFiles()) {
			file.active = file.filename == activeTabFilename.value;
			file.openInEditor = tabsList.value.map((tab) => tab.filename).includes(file.filename);
			file.openByLector = tabsList.value.map((tab) => tab.filename).includes(file.filename);
			file.isLectorActive = file.filename == lectorState.value.activeEditor.filename;
		}
	}
});

function onFileSystemClickDirectory(entryDirectory:IDESideBarContentTabFileSystem.FSEntryDirectory) {
	entryDirectory.expanded = !entryDirectory.expanded;
}
function onFileSystemClickFile(entryFile:IDESideBarContentTabFileSystem.FSEntryFile) {
	const alreadyOpen = tabsList.value.find((tab) => tab.filename == entryFile.filename) !== undefined;
	if (!alreadyOpen) {
		userOpenFiles.value.push({filename: entryFile.filename});
	}
	forcedSelectedTabFilename.value = entryFile.filename;
	onStudentActivity();
}


// seznam stahovani
const downloads = ref<Array<IDESideBarContentTabDownload.Download>>([]);
//!FIXME
// downloads.value.push(new IDESideBarContentTabDownload.Download('123', 'aaa.zip'));
// downloads.value[0].totalSize = 1024*1024*5.5;
// downloads.value[0].downloadedSize = 1024*1024*0.5;
// downloads.value.push(new IDESideBarContentTabDownload.Download('1234', 'src.zip'));
// downloads.value[1].totalSize = 1024*1024*0.4;
// downloads.value[1].downloadedSize = 1024*1024*0.3;
// downloads.value.push(new IDESideBarContentTabDownload.Download('12345', 'src.zip'));

function removeDownload(downloadId:string) {
	downloads.value = downloads.value.filter((downloadItem) => downloadItem.downloadId != downloadId);
}

// stahovani souboru
async function onDownload(downloadOptions:IDESideBarContentTabDownload.DownloadOptions) {
	if (!appConfig.value) {
		return;
	}
	//console.log({downloadOptions});
	const downloadResult = await racProxyCall('download', [downloadOptions]);
	//console.log({downloadResult});

	if (downloadResult.status == 200) {
		downloads.value.push(new IDESideBarContentTabDownload.Download(downloadResult.download.id, downloadResult.download.filename));
		const download = downloads.value[downloads.value.length - 1];

		const downloadUrl = `${appConfig.value.api.webUrl}/${downloadResult.download.url}`;

		fetch(downloadUrl).then(res => {
			if (res.status != 200) {
				alert('Soubor nelze stáhnout');
				return;
			}
			const readableStream = res.body;
			if (!readableStream) {
				return;
			}

			streamSaver.mitm = '/streamer.js/mitm.html';
			streamSaver.WritableStream = WritableStream; // pouziti polyfillu pro firefox
			const fileStream = streamSaver.createWriteStream(downloadResult.download.filename);
			const writer = fileStream.getWriter();

			const reader = res.body.getReader();
			const pump = async () => {
				try {
					const res = await reader.read();

					if (res.done) {
						writer.close();
						// odstranit ze seznamu stahovani
						removeDownload(download.downloadId);
					}else {
						if (res.value) {
							try {
								await writer.write(res.value);
							}catch (err) {
								console.error('Aborted', err);
								// odstranit ze seznamu stahovani
								removeDownload(download.downloadId);
								return;
							}
							// aktualizovat kolik toho bylo stazeno
							download.downloadedSize = (download.downloadedSize || 0) + res.value.length;
							pump();
						}
					}
				}catch (err) {
					console.error(err);
					removeDownload(download.downloadId);
				}
			};

			pump();
		});
	}else {
		alert("Nastala chyba při stahování");
	}
}


// nastaveni
const settings = ref<IDESideBarContentTabSettings.Settings>({
	fontSize: 18,
	wordWrap: false,
	sideBarContentShown: false,
});

function onSettingsChanged(newSettings:IDESideBarContentTabSettings.Settings) {
	//console.log('onSettingsChanged', {newSettings});
	if (newSettings.fontSize !== undefined) {
		settings.value.fontSize = newSettings.fontSize;
	}
	if (newSettings.wordWrap !== undefined) {
		settings.value.wordWrap = newSettings.wordWrap;
	}
	if (newSettings.sideBarContentShown !== undefined) {
		settings.value.sideBarContentShown = newSettings.sideBarContentShown;
	}
	// ulozit nastaveni
	localStorage.setItem("settings", JSON.stringify(settings.value));
}
// nacist nastaveni na zacatku
onMounted(() => {
	const settingJson = localStorage.getItem("settings");
	if (settingJson) {
		const storedSettings = JSON.parse(settingJson);
		if (storedSettings.fontSize !== undefined) {
			settings.value.fontSize = storedSettings.fontSize;
		}
		if (storedSettings.wordWrap !== undefined) {
			settings.value.wordWrap = storedSettings.wordWrap;
		}
		if (storedSettings.sideBarContentShown !== undefined) {
			settings.value.sideBarContentShown = storedSettings.sideBarContentShown;
		}
	}
});
function onSideBarContentShownChanged(shown:boolean) {
	onSettingsChanged({
		sideBarContentShown: shown,
	});
}

// sledovat zmenu videa
watch(() => lectorCodeState.value?.chapter, () => {
	if (lectorCodeState.value && lectorCodeState.value.chapter) {
		//console.log(lectorCodeState.value.chapter);
		const parts = [lectorCodeState.value.chapter.title, ...lectorCodeState.value.chapter.subtitle, lectorCodeState.value.chapter.name];
		document.title = `LectorCodeViewer - ${parts.reverse().join(' < ')}`;
	}
}, {deep: true});

function openInNewWindow() {
	const windowFeatures = "left=100,top=100,width=800,height=600";
	const handle = window.open(`#/view/${props.playbackSessionId}`, "_blank", windowFeatures);
	if (!handle) {
		window.open(`#/view/${props.playbackSessionId}`, "_blank");
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "lectorCodeViewer",
    onClick: onClick
  }, [
    (_unref(isVideoPlayerPlaybackSessionClientDisconnected))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", { class: "items" }, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", null, [
              _createElementVNode("button", { onClick: closeWindow }, "Zavřít okno")
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.debug)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createTextVNode("PlaybackSessionId: " + _toDisplayString(__props.playbackSessionId) + " ", 1),
                  _createElementVNode("a", {
                    href: `#/view/${__props.playbackSessionId}`,
                    target: "_blank"
                  }, "Open in new window", 8, _hoisted_6)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_7,
                  (lectorCodeState.value)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_8, [
                        _createElementVNode("tr", null, [
                          _hoisted_9,
                          _createElementVNode("td", null, _toDisplayString(lectorCodeState.value.recordingSessionId), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_10,
                          _createElementVNode("td", null, _toDisplayString(lectorCodeState.value.loaded), 1)
                        ]),
                        (lectorCodeState.value.loaded)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (lectorCodeState.value.chapter)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                    _hoisted_12,
                                    _createElementVNode("td", _hoisted_13, [
                                      _createElementVNode("h3", null, _toDisplayString(lectorCodeState.value.chapter.title) + " >", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectorCodeState.value.chapter.subtitle, (subtitle, index) => {
                                        return (_openBlock(), _createElementBlock("h4", { key: index }, _toDisplayString(subtitle) + " >", 1))
                                      }), 128)),
                                      _createElementVNode("h5", null, _toDisplayString(lectorCodeState.value.chapter.name), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("tr", null, [
                                _hoisted_14,
                                _createElementVNode("td", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (workspace) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: workspace.getNormalizedDirname()
                                    }, _toDisplayString(workspace.getNormalizedDirname()), 1))
                                  }), 128))
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createElementVNode("table", _hoisted_16, [
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", null, _toDisplayString(lectorState.value.lectorEditorReady), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (appConfig.value && lectorCodeState.value && lectorCodeState.value.loaded && lectorCodeState.value.usable && lectorState.value.lectorEditorReady)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(IDEWindow.default, {
                  ref_key: "IDEWindowInstance",
                  ref: IDEWindowInstance,
                  loading: pendingCalls.value.size > 0,
                  sideBar: {
						followLectorActivity: followLectorActivity.value.active,
						videoIsPlaying: lectorCodeState.value != null && lectorCodeState.value.playing,
					},
                  sideBarContent: {
						shown: settings.value.sideBarContentShown !== undefined ? settings.value.sideBarContentShown : true,
						tabs: {
							fileSystem: {
								workspaces: workspaces.value,
							},
							settings: {
								settings: settings.value,
							},
							download: {
								downloads: downloads.value,
							}
						},
					},
                  tabs: {tabsList: tabsList.value},
                  textEditor: {
						hidden: activeTabFilename.value == null || activeTabFileContentType.value != FileContentType.text,
						readOnly: true,
						fontSize: settings.value.fontSize !== undefined ? settings.value.fontSize : 18,
						wordWrap: settings.value.wordWrap !== undefined ? settings.value.wordWrap : false,
						content: editor.value.content,
						modelLanguage: editor.value.modelLanguage,
						followVirtualCursor: _unref(isLectorEditorActive) && followLectorActivity.value.active,
						virtualCursorPosition: _unref(isLectorEditorActive) ? lectorState.value.activeEditor.cursorPosition : null,
						virtualSelections: _unref(isLectorEditorActive) ? lectorState.value.activeEditor.selections : [],
					},
                  viewerContentTypeUnknown: {
						filename: activeTabFilename.value,
						hidden: activeTabFileContentType.value != FileContentType.unknown,
					},
                  "onSideBar:onFollowLectorActivityChanged": onFollowLectorActivityChanged,
                  "onTabs:onSelectTab": onSelectTab,
                  "onTabs:onCloseTab": onCloseTab,
                  "onTextEditor:onMouseDown": onTextEditorMouseDown,
                  "onTextEditor:onKeyDown": onTextEditorKeyDown,
                  "onTextEditor:onDidScrollChange": onTextEditorDidScrollChange,
                  "onSideBarContent:tabs:fileSystem:onClickDirectory": onFileSystemClickDirectory,
                  "onSideBarContent:tabs:fileSystem:onClickFile": onFileSystemClickFile,
                  "onSideBarContent:tabs:download:onDownload": onDownload,
                  "onSideBarContent:tabs:settings:onSettingsChanged": onSettingsChanged,
                  "onSideBarContent:onShownChanged": onSideBarContentShownChanged,
                  onOpenInNewWindow: openInNewWindow
                }, null, 8, ["loading", "sideBar", "sideBarContent", "tabs", "textEditor", "viewerContentTypeUnknown"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (appConfig.value && lectorCodeState.value && lectorCodeState.value.loaded && !lectorCodeState.value.usable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_23))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, _hoisted_27))
              ]))
        ], 64))
  ]))
}
}

})